module.exports = __webpack_public_path__ + "static/eclipse2-5d8e8cb15b56e9f981e901952b5be4cd.png";